import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getPDF } from "store/swList/swListActions";
import { showErrorToast, showInfoToast } from "store/toast/toastActions";
import useSelector from "store/useSelector";

interface IDownloadLatestPdfByGuidAndType {

}

const DownloadLatestPdfByGuidAndType: React.FC<IDownloadLatestPdfByGuidAndType> = (props) => {
    const {swGuid: guidFromParams, pdfType: pdfTypeFromParams} = useParams();
    const swGuid = window.decodeURIComponent(guidFromParams!);
    const pdfType = window.decodeURIComponent(pdfTypeFromParams!);
    const dispatch = useDispatch();
    const {
        getPDFData: {
            getPdfOperation,
        }
    } = useSelector(store => store.swList);

    useEffect(() => {
        dispatch(
            getPDF({
                swId: 0,
                swGuid: swGuid,
                getLatestVersion: true,
                pdfType: pdfType
            })
        );
    }, [swGuid, pdfType, dispatch]);

    if (getPdfOperation?.errorMessage) {
        dispatch(showErrorToast("Error getting PDF"));
    } else if (getPdfOperation?.wasSuccessful) {
        dispatch(showInfoToast("PDF generated & downloaded successfully"));
    }

    return <></>;
}

export default DownloadLatestPdfByGuidAndType;